<div class="title p-2">
    <div class="row">
        <div class="col d-flex justify-content-start">
            <h1 class="mx-1">Actualizează valabilitatea</h1>

        </div>
        <div class="col d-flex justify-content-end">
            <button type="button" class="action-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <div class="row p-2">
        <div class="col">
            <form [formGroup]="form" (ngSubmit)="submitRegistruValability()">
                <div class="row">
                    <div class="col">
                        <mat-form-field appearance="fill">
                            <mat-label>Valabilitate</mat-label>
                            <input matInput [matDatepicker]="pickerValabil" formControlName="valability" readonly
                                (focus)="pickerValabil.open()" />
                            <mat-error *ngIf="
                                !form.controls['valability'].valid &&
                                form.controls['valability'].touched
                              ">
                                Câmp obligatoriu
                            </mat-error>
                            <mat-hint>LL/ZZ/AAAA</mat-hint>
                            <mat-datepicker-toggle matIconSuffix [for]="pickerValabil"></mat-datepicker-toggle>
                            <mat-datepicker #pickerValabil></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col d-flex">
                        <button type="button" class="btn btn-secondary mr-8" (click)="addMonthsToValability(12)">Valabilitate
                            12 luni</button>
                        <button type="button" class="btn btn-secondary" (click)="addMonthsToValability(24)">Valabilitate
                            24 luni</button>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col d-flex justify-content-between">
                        <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                            {{ helper.dialogConfig.buttonLabels.close }}
                        </button>
                        <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                            {{ helper.dialogConfig.buttonLabels.save }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <div class="section-spinner" *ngIf="isLoading"
            style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5);">
            <div class="spinner" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                <mat-spinner></mat-spinner>
                <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
            </div>
        </div>
    </div>